import { useState } from "react";
import { Trash2 } from "lucide-react";
import { api, act, useFetch } from "@/lib/api";
import { Panel, Badge } from "@/components/common";
import { Sel } from "@/components/Sel";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const slug = (e) => e.replace(/[^a-z0-9]/gi, "-");

const Row = ({ p, roles, setData }) => (
  <div className="flex items-center gap-3 py-2 text-sm" data-testid={`access-row-${slug(p.email)}`}>
    <span className="flex-1 truncate">{p.email}</span>
    <Badge v={p.signed_in ? "signed in" : "not yet"} tone={p.signed_in ? "green" : "gray"} />
    {p.owner ? <span className="w-32 text-xs text-zinc-400" data-testid={`access-owner-${slug(p.email)}`}>Owner · admin</span> : (
      <Sel testid={`access-role-${slug(p.email)}`} className="w-32" value={p.role} options={roles}
        onChange={(v) => act(() => api.post("/access", { email: p.email, role: v }), "Role updated").then((r) => r && setData(r))} />
    )}
    <Button size="icon" variant="ghost" disabled={p.owner} data-testid={`access-remove-${slug(p.email)}`} aria-label="Remove access"
      onClick={() => act(() => api.delete(`/access/${encodeURIComponent(p.email)}`), "Access removed").then((r) => r && setData(r))}>
      <Trash2 className="w-4 h-4" />
    </Button>
  </div>
);

export const AccessPanel = () => {
  const { data, setData } = useFetch("/access");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("member");
  if (!data) return null;
  const add = async () => {
    const r = await act(() => api.post("/access", { email, role }), "Access granted");
    if (r) { setData(r); setEmail(""); }
  };
  return (
    <Panel title="Who can sign in">
      <p className="text-[11px] text-zinc-500 mb-2">Only these emails can use the app. Admins can approve Go-Live and change settings; members do day-to-day work.</p>
      <div className="divide-y divide-border/60" data-testid="access-list">{data.people.map((p) => <Row key={p.email} p={p} roles={data.roles} setData={setData} />)}</div>
      <div className="flex gap-2 mt-3">
        <Input data-testid="access-email-input" placeholder="name@company.com" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-black" />
        <Sel testid="access-new-role" className="w-32" value={role} onChange={setRole} options={data.roles} />
        <Button data-testid="access-add-btn" disabled={!email.trim()} onClick={add} className="bg-[#007AFF] hover:bg-[#3395FF]">Add</Button>
      </div>
    </Panel>
  );
};
